import axios from 'axios'

axios.defaults.withCredentials = true

// axios.defaults.baseURL = process.env.NODE_ENV === 'production' ? 'https://api.der-supertolle-quizabend.de/api' : 'http://192.168.11.13:3000/api';
axios.defaults.baseURL = process.env.NODE_ENV === 'production' ? 'https://api.der-supertolle-quizabend.de/api' : 'http://192.168.178.63:3000/api';
console.log('API Axios base URL:', axios.defaults.baseURL)
const api = axios.create({withCredentials : true});

export default api;